/* eslint-disable no-console */
import { datadogLogs, HandlerType } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { isMonitoringEnabled } from './isMonitoringEnabled';

export const initMonitoring = (service: 'external' | 'internal') => {
  if (isMonitoringEnabled()) {
    console.debug('Initializing monitoring', {
      env: import.meta.env.VITE_ENV,
      environment: import.meta.env,
      service,
      version: import.meta.env.VITE_APP_VERSION,
    });

    datadogRum.init({
      allowedTracingUrls: [
        {
          match: (url: string) => url.startsWith(`${window.location.origin}/api`),
          propagatorTypes: ['datadog', 'tracecontext'],
        },
      ],
      applicationId: '2c96bd55-a011-4b9f-82f5-ec6296ef2baf', //TODO: store in env var https://linear.app/safi/issue/PLA-105/store-env-vars-in-secret-manager
      clientToken: 'pube117b27c2ffaa3683e0ab79e75e5e166', //TODO: store in env var https://linear.app/safi/issue/PLA-105/store-env-vars-in-secret-manager
      defaultPrivacyLevel: 'allow',
      env: import.meta.env.VITE_ENV,
      service,
      sessionReplaySampleRate: 100,
      sessionSampleRate: 100,
      site: 'datadoghq.eu',
      traceSampleRate: 100,
      trackLongTasks: true,
      trackResources: true,
      trackUserInteractions: true,
      version: import.meta.env.VITE_APP_VERSION,
    });

    datadogLogs.init({
      clientToken: 'puba4e763aded7ecf3e8d920b66321d64e0', //TODO: store in env var https://linear.app/safi/issue/PLA-105/store-env-vars-in-secret-manager
      env: import.meta.env.VITE_ENV,
      forwardConsoleLogs: 'all',
      forwardErrorsToLogs: true,
      forwardReports: 'all',
      service,
      sessionSampleRate: 100,
      site: 'datadoghq.eu',
      version: import.meta.env.VITE_APP_VERSION,
    });

    const isLocalHost = window.location.hostname === 'localhost';

    datadogLogs.logger.setHandler(isLocalHost ? [HandlerType.console] : [HandlerType.http]);
  }
};
